class WSMessage {
  constructor() {
    this.MessageTypes = {
      ChangeObject: 100,
      ChangeProperty: 200,
      Custom: 300,
    };
    this.Stores = {
      Dashboard: 100,
      Discovery: 200,
    };
    this.DashboardObjects = {
      MiniDashboard: 100,
      SanityCheck: 200,
      MyLearning: 300,
      EbayData: 400,
    };
  }

  updateObject(obj, prop, value) {
    if (prop !== null) {
      obj[prop] = value;
    } else {
      for (let property in obj) {
        if (obj.hasOwnProperty(property)) {
          if (value.hasOwnProperty(property)) {
            obj[property] = value[property];
          }
        }
      }
    }
  }
}

export default new WSMessage();
